<template>
  <div class="skill">
    <div class="header">
      <template v-for="level in Object.keys(levelMap)">
        <div
          v-if="level"
          :key="level"
          class="item"
          :class="[activeLevel == level ? 'active' : '']"
          @click="handleTabsChange(level)"
        >
          <img :src="levelMap[level].icon" alt="" />
        </div>
        <div :key="level + 'd'" class="divider" v-if="level != 7"></div>
      </template>
      <!--<div class="contrast-btn" @click="openSkillContrast">强化数值对比</div>-->
    </div>
    <div class="base">
      <img class="icon" alt="" :src="dataSource.icon.value" />
      <div class="info">
        <div class="left">
          <div class="name">
            <span>{{ $t("tj.zs.jn") }}：{{ dataSource.name.value }}</span>
            <div class="skill-btn" @click="openSkillContrast">
              <img src="@/assets/zs_imgs/skill-enhancement.png" alt="" class="skill-enhan" />{{ $t("tj.zs.qh") }}
            </div>
          </div>
          <div class="attr">
            <img src="@/assets/zs_imgs/rectangle-btn.png" alt="" />
            <span class="item">
              SP
              <span style="color: #FFBC5E;">{{ dataSource.upgrade["level" + activeLevel].sp.value }}</span>
            </span>
            <span class="item">
              CD
              <span style="color: #FFBC5E;"> {{ dataSource.upgrade["level" + activeLevel].cd.value }}</span>
            </span>
          </div>
        </div>
        <div class="right">
          <div class="video-btn" v-if="dataSource.video.hasValue && dataSource.video.value" @click="openVideo">
            {{ $t("tj.zs.jndh") }}
          </div>
        </div>
      </div>
    </div>
    <div class="desc">
      <span v-html="highlightNumbers(dataSource.upgrade['level' + activeLevel].desc.value)"></span>
    </div>
    <div class="effect">
      <div>
        <span>{{ dataSource.ability1.name.value }}</span
        >：<span class="effect-desc">{{ formatLangValue(dataSource.ability1.desc.value) }}</span>
      </div>
      <div>
        <span>{{ dataSource.ability2.name.value }}</span
        >：<span class="effect-desc">{{ formatLangValue(dataSource.ability2.desc.value) }}</span>
      </div>
    </div>
    <div class="other-attr">
      <div class="left">
        <div class="item">
          <img class="icon" alt="" :src="dataSource.attr1.icon.value" />
          <span>{{ dataSource.attr1.name.value }}</span>
        </div>
        <div class="item">
          <img class="icon" alt="" :src="dataSource.attr2.icon.value" />
          <span>{{ dataSource.attr2.name.value }}</span>
        </div>
        <div class="item">
          <img class="icon" alt="" :src="dataSource.upgrade['level' + activeLevel].icon.value" />
          <span>{{ dataSource.attr3.name.value }}</span>
        </div>
      </div>
      <!--<div class="right">
        <div
          class="video-btn"
          v-if="dataSource.video.hasValue && dataSource.video.value"
          @click="openVideo"
          title="技能动画"
        >
          <img src="@/assets/zs_imgs/skill-video-btn.png" alt="" />
        </div>
      </div> -->
    </div>

    <div class="more-content">
      <div class="title">
        <img class="icon" src="@/assets/zs_imgs/skill-more-title-icon.png" alt="" />
        {{ $t("tj.zs.jnql") }}
      </div>
      <div class="potential" v-if="!isEmptyPotential">
        <template v-for="key in Object.keys(dataSource.potential)">
          <div
            class="item"
            :key="key"
            v-if="dataSource.potential[key].icon.hasValue && dataSource.potential[key].icon.value"
          >
            <img class="icon" :src="dataSource.potential[key].icon.value" alt="" />
            <span class="desc" v-if="dataSource.potential[key].desc.value">{{
              dataSource.potential[key].desc.value
            }}</span>
            <img class="desc-icon" v-else :src="dataSource.potential[key].iconDesc.value" alt="" />
          </div>
        </template>
      </div>
    </div>
    <div class="line"></div>
    <TalentSkill :dataSource="talentDataSource" />
    <SkillPreview v-model="skillPreview" :dataSource="dataSource" :levelMap="levelMap" :activeLevel="activeLevel" />
    <!-- 强化数值对比 -->
    <el-dialog
      append-to-body
      custom-class="el-dialog-clearstyle-class skill-contrast-dialog"
      :visible.sync="skillVisible"
      top="7vh"
      width="820px"
    >
      <div class="skill-contrast-header">
        <div class="name">{{ current.name.value }}</div>
        <div class="attr">
          <div class="item">
            <img class="icon" alt="" :src="dataSource.attr1.icon.value" />
            <span>{{ dataSource.attr1.name.value }}</span>
          </div>
          <div class="item">
            <img class="icon" alt="" :src="dataSource.attr2.icon.value" />
            <span>{{ dataSource.attr2.name.value }}</span>
          </div>
          <!-- <div class="item">
            <img class="icon" alt="" :src="dataSource.upgrade['level' + activeLevel].icon.value" />
            <span>{{ dataSource.attr3.name.value }}</span>
          </div> -->
        </div>
        <div class="close-btn" @click="closeSkillContrast">
          <SvgIcon icon-class="wiki-close" />
        </div>
      </div>
      <div class="skill-contrast-container">
        <table class="skill-table" border="0">
          <colgroup>
            <col style="width: 65px" />
            <col style="width: 65px" />
            <col style="width: 69px" />
            <col style="width: 65px" />
            <col style="width: 486px" />
          </colgroup>
          <thead>
            <tr>
              <th style="text-align: center;">{{ $t("tj.zs.sz.qh") }}</th>
              <th style="text-align: center;">{{ $t("tj.zs.sz.xh") }}</th>
              <th style="text-align: center;">{{ $t("tj.zs.sz.lqsj") }}</th>
              <th style="text-align: center;">{{ $t("tj.zs.sz.jnfw") }}</th>
              <th style="text-align: center;">{{ $t("tj.zs.sz.jnxg") }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(level, index) in Object.keys(dataSource.upgrade)">
              <tr v-if="index !== 6" :key="level">
                <td style="text-align: center; padding: 0;">
                  <img :src="levelMap[index + 1].icon" alt="" style="width: 44px;vertical-align: middle;" />
                </td>
                <td style="text-align: center;padding: 0">
                  <img
                    v-if="dataSource.upgrade[level].sp.hasValue && dataSource.upgrade[level].sp.value"
                    :src="require(`@/assets/zs_imgs/skill-sp-icon.png`)"
                    style="width: 10px;vertical-align: middle;margin-bottom: 2px"
                    alt=""
                  />
                  <span
                    v-if="dataSource.upgrade[level].sp.hasValue && dataSource.upgrade[level].sp.value"
                    style="color: #ffbc5e; margin-left: 4px"
                    >{{ dataSource.upgrade[level].sp.value }}<span style="color: #fff">SP</span></span
                  >
                </td>
                <td style="text-align: center;color:#fff">
                  <span v-if="dataSource.upgrade[level].cd.hasValue && dataSource.upgrade[level].cd.value"
                    >{{ dataSource.upgrade[level].cd.value }}{{ $t("tj.zs.sz.hh") }}</span
                  >
                </td>
                <td style="text-align: center; padding: 0;">
                  <img :src="dataSource.upgrade[level].icon.value" style="width: 36px;vertical-align: middle;" />
                </td>
                <td v-html="highlightNumbers(dataSource.upgrade[level].desc.value)"></td>
              </tr>
              <tr v-if="index === 6" :key="level" class="level6-tr">
                <td style="text-align: center; padding: 0;">
                  <img :src="levelMap[6].icon" style="width: 44px;vertical-align: middle;" />
                  <div class="bottom-container">
                    <img src="@/assets/zs_imgs/sum.svg" style="width: 8px;vertical-align: middle;" />
                    <img :src="levelMap[7].icon" style="width: 22px;vertical-align: middle;" />
                  </div>
                </td>
                <td style="text-align: center;padding: 0">
                  <img
                    v-if="dataSource.upgrade[level].sp.hasValue && dataSource.upgrade[level].sp.value"
                    :src="require(`@/assets/zs_imgs/skill-sp-icon.png`)"
                    style="width: 10px;vertical-align: middle;margin-bottom: 2px"
                  />
                  <span
                    v-if="dataSource.upgrade[level].sp.hasValue && dataSource.upgrade[level].sp.value"
                    style="color: #ffbc5e; margin-left: 4px"
                    >{{ dataSource.upgrade[level].sp.value }}<span style="color: #fff">SP</span></span
                  >
                </td>
                <td style="text-align: center;color:#fff">
                  <span v-if="dataSource.upgrade[level].cd.hasValue && dataSource.upgrade[level].cd.value"
                    >{{ dataSource.upgrade[level].cd.value }}{{ $t("tj.zs.sz.hh") }}</span
                  >
                </td>
                <td style="text-align: center; padding: 0;">
                  <img :src="dataSource.upgrade[level].icon.value" style="width: 36px;vertical-align: middle;" />
                </td>
                <td v-html="highlightNumbers(dataSource.upgrade[level].desc.value)"></td>
              </tr>
            </template>
          </tbody>
        </table>

        <table class="potential-table" border="0" v-if="!isEmptyPotential">
          <colgroup>
            <col style="width: 33%" />
            <col style="width: 33%" />
            <col style="width: 34%" />
          </colgroup>
          <thead>
            <tr>
              <th style="text-align: center;" colspan="3">{{ $t("tj.zs.jnql") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <template v-for="key in Object.keys(dataSource.potential)">
                <td :key="key" v-if="dataSource.potential[key].icon.hasValue && dataSource.potential[key].icon.value">
                  <span class="desc" v-if="dataSource.potential[key].desc.value">{{
                    dataSource.potential[key].desc.value
                  }}</span>
                  <img class="desc-icon" v-else :src="dataSource.potential[key].iconDesc.value" alt="" />
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
    <!-- 显示技能视频 -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="video-dialog"
      :visible.sync="videoVisible"
      :after-close="closeVideo"
    >
      <div class="video-container">
        <!-- 判断是否需要实名认证 -->
        <template v-if="dataSource.video.isLimit">
          <span style="position: relative;">
            <video :poster="dataSource.video.value" controls autoplay muted></video>
            <LimitVideoTips style="position: absolute;bottom: 80px;left: 11px;" />
          </span>
        </template>
        <template v-else>
          <video :src="dataSource.video.value" controls autoplay muted></video>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TalentSkill from "./talentSkill.vue";
import SkillPreview from "./skillPreview.vue";
import LimitVideoTips from "@/views/wiki/tj/zs/components/LimitVideoTips.vue";

export default {
  components: { TalentSkill, LimitVideoTips, SkillPreview },
  props: {
    current: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    talentDataSource: { type: Object, default: () => ({}) }
  },
  inject: {
    refreshMap: {
      default: () => {}
    }
  },
  data() {
    return {
      drawer: false,
      videoVisible: false,
      skillVisible: false,
      activeLevel: 6,
      levelMap: {
        1: {
          icon: require(`@/assets/zs_imgs/skill-icon-0.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-1-acitve.png`)
        },
        2: {
          icon: require(`@/assets/zs_imgs/skill-icon-1.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-1-acitve.png`)
        },
        3: {
          icon: require(`@/assets/zs_imgs/skill-icon-2.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-2-acitve.png`)
        },
        4: {
          icon: require(`@/assets/zs_imgs/skill-icon-3.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-3-acitve.png`)
        },
        5: {
          icon: require(`@/assets/zs_imgs/skill-icon-4.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-4-acitve.png`)
        },
        6: {
          icon: require(`@/assets/zs_imgs/skill-icon-5.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-5-acitve.png`)
        },
        7: {
          icon: require(`@/assets/zs_imgs/skill-icon-full.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-full-acitve.png`)
        }
      },
      skillPreview: false
    };
  },
  computed: {
    isEmptyPotential() {
      return !Object.keys(this.dataSource.potential).some(key => {
        return this.dataSource.potential[key].icon.hasValue && this.dataSource.potential[key].icon.value;
      });
    }
  },
  methods: {
    handleTabsChange(level) {
      this.activeLevel = level;
    },
    openVideo() {
      this.burialPoint("Brown_character_web_click_Ultimate_Animation_button");
      this.videoVisible = true;
    },
    closeVideo() {
      this.videoVisible = false;
    },
    highlightNumbers(str) {
      return str.replace(/(\d+\.?\d*%?)/g, `<span style="color: #FFBC5E;">$1</span>`);
    },
    openSkillContrast() {
      this.skillVisible = true;
      this.burialPoint("Brown_character_web_click_Enhancement_Value_button");
    },
    closeSkillContrast() {
      this.skillVisible = false;
    },
    formatLangValue(value) {
      const attrLangMap = {
        生命力: this.$t("tj.zs.生命力"),
        攻击力: this.$t("tj.zs.攻击力"),
        魔法力: this.$t("tj.zs.魔法力"),
        致命率: this.$t("tj.zs.致命率"),
        致命伤害: this.$t("tj.zs.致命伤害"),
        防御力: this.$t("tj.zs.防御力"),
        魔法抵抗: this.$t("tj.zs.魔法抵抗"),
        火属性伤害: this.$t("tj.zs.火属性伤害"),
        风属性伤害: this.$t("tj.zs.风属性伤害"),
        水属性伤害: this.$t("tj.zs.水属性伤害"),
        光属性伤害: this.$t("tj.zs.光属性伤害"),
        暗属性伤害: this.$t("tj.zs.暗属性伤害"),
        火属性抵抗: this.$t("tj.zs.火属性抵抗"),
        风属性抵抗: this.$t("tj.zs.风属性抵抗"),
        水属性抵抗: this.$t("tj.zs.水属性抵抗"),
        属性抵抗: this.$t("tj.zs.属性抵抗")
      };
      if (!value) return value;
      const attrs = Object.keys(attrLangMap);
      let formattedValue = value;
      attrs.forEach(attr => {
        const regex = new RegExp(attr, "g");
        formattedValue = formattedValue.replace(regex, attrLangMap[attr]);
      });
      return formattedValue;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .skill-contrast-dialog {
  background: linear-gradient(180deg, #262f3a 0%, #252b36 100%), linear-gradient(155deg, #262f3a 0%, #31415e 100%);
  border-radius: 12px;
  position: absolute;
  left: 43%;
  transform: translateX(-70%);

  .skill-contrast-header {
    position: relative;
    padding: 27px 20px;
    display: flex;
    align-items: flex-end;

    .name {
      font-family: SourceHanSansCN;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      line-height: 42px;
      margin-right: 30px;
    }

    .attr {
      display: flex;
      align-items: center;

      .item {
        display: flex;
        align-items: center;
        font-family: SourceHanSansCN;
        font-weight: 800;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        margin-right: 30px;

        .icon {
          width: 32px;
          height: 32px;
          border-radius: 3px;
          border: 1px solid #5a5a5a;
          margin-right: 9px;
        }
      }
    }

    .close-btn {
      font-size: 20px;
      color: #fff;
      position: absolute;
      top: 27px;
      right: 20px;
      cursor: pointer;
    }
  }

  .skill-contrast-container {
    padding: 8px 20px 26px;

    .skill-table {
      table-layout: fixed;
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;

      thead {
        height: 32px;
        background: rgba(255, 255, 255, 0.08);
      }

      th {
        border-top: none;
        border-left: 1px solid rgba(255, 255, 255, 0.08);
        border-bottom: none;
        border-right: 1px solid rgba(255, 255, 255, 0.1);
        font-family: SourceHanSerifSC;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }

      tbody {
        tr {
          &:first-child {
            td {
              border-top: none;
            }
          }
        }

        td {
          padding: 16px 13px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          font-weight: 500;
          font-size: 16px;
          color: #d3d3d3;
          line-height: 22px;
        }
      }
      .level6-tr {
        td:nth-child(1) {
          .bottom-container {
            display: flex;
            align-items: center;
            justify-content: center;
            column-gap: 2px;
          }
        }
      }
    }

    .potential-table {
      table-layout: fixed;
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      margin-top: 16px;

      thead {
        height: 32px;
        background: rgba(255, 255, 255, 0.08);
      }

      th {
        border-top: none;
        border-left: 1px solid rgba(255, 255, 255, 0.08);
        border-bottom: none;
        border-right: 1px solid rgba(255, 255, 255, 0.1);

        font-family: SourceHanSerifSC, SourceHanSerifSC;
        font-weight: 800;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;

        &:last-child {
          border-right: none;
        }
      }

      tbody {
        tr {
          &:first-child {
            td {
              border-top: none;
            }
          }
        }

        td {
          padding: 5px 13px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          font-weight: 500;
          font-size: 16px;
          color: #fff;
          line-height: 22px;

          .icon {
            width: 26px;
            height: 26px;
            background: #222337;
            border-radius: 4px;
            border: 1px solid #656f74;
            vertical-align: middle;
            margin-right: 9px;
          }

          .desc {
            font-weight: 400;
            font-size: 16px;
            color: #fff;
            line-height: 20px;
          }

          .desc-icon {
            width: 26px;
            height: 26px;
            border-radius: 4px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

/deep/ .video-dialog {
  background-color: rgba(0, 0, 0, 0.9);

  .el-dialog__header {
    padding: 0;
    position: relative;
    margin: 0 auto;
    width: 1000px;

    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }

    .el-icon-close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .video-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;

    video {
      width: 960px;
    }
  }
}

.skill {
  width: 100%;
  padding-left: 4px;
  margin-bottom: 50px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 20px;
    margin-bottom: 30px;

    .item {
      position: relative;
      width: 100%;
      height: 40px;
      cursor: pointer;
      text-align: center;

      img {
        width: 40px;
        height: 40px;
        opacity: 0.3;
      }

      &.active {
        img {
          opacity: 1;
        }
      }
    }

    // &::before,
    // &::after {
    //   content: "";
    //   display: inline-block;
    //   width: 1px;
    //   height: 24px;
    //   background: rgba(255, 255, 255, 0.08);
    // }
    .divider {
      width: 1px;
      height: 24px;
      background: rgba(255, 255, 255, 0.08);
    }

    .contrast-btn {
      flex-shrink: 0;
      width: 100px;
      height: 25px;
      background: #e1dad5;
      border-radius: 21px;
      font-weight: bold;
      font-size: 13px;
      color: #473228;
      line-height: 25px;
      text-align: center;
      cursor: pointer;
    }
  }

  .base {
    display: flex;
    align-items: center;
    height: 58px;
    margin-bottom: 8px;

    .icon {
      flex-shrink: 0;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      margin-right: 19px;
    }

    .info {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        flex-direction: column;
        row-gap: 5px;
        justify-content: space-between;

        .skill-btn {
          margin-left: 5px;
          width: 78px;
          height: 30px;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          font-size: 15px;
          color: #e1dad5;
          cursor: pointer;

          img {
            width: 22px;
            height: 22px;
            margin-right: 6px;
          }
        }
      }

      .name {
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        line-height: 20px;
      }

      .attr {
        display: flex;
        align-items: center;
        font-size: 16px;

        img {
          width: 8px;
          height: 8px;
          margin-right: 10px;
        }

        .item {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 20px;
          margin-right: 20px;
        }
      }

      .right {
        height: 30px;
        display: flex;
        align-items: center;
        align-self: flex-start;
      }

      .video-btn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100px;
        height: 25px;
        background: #e1dad5;
        border-radius: 21px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 13px;
        color: #473228;
        line-height: 20px;
        cursor: pointer;
        padding: 0 10px;

        &::before {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 7px solid #000000;
          border-radius: 2px;
        }
      }
    }
  }

  & > .desc {
    font-weight: 400;
    font-size: 18px;
    color: #bbbbbb;
    line-height: 28px;
    margin-bottom: 10px;
  }

  .effect {
    margin-bottom: 24px;

    .effect-desc {
      color: #bbbbbb;
    }

    div {
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      margin-bottom: 9px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .other-attr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .left {
      display: flex;
      gap: 53px;
    }

    .right {
      .video-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        background: rgba(0, 0, 0, 0.25);
        border-radius: 4px;
        cursor: pointer;

        img {
          width: 30px;
          height: 30px;
        }
      }
    }

    .item {
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      gap: 11px;

      .icon {
        width: 42px;
        height: 42px;
      }
    }
  }

  .more-content {
    width: 100%;

    & > .title {
      position: relative;
      width: 160px;
      height: 20px;
      background: linear-gradient(90deg, rgba(34, 82, 100, 0.87) 21%, rgba(34, 82, 100, 0) 100%);
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 20px;
      margin-left: 10px;
      padding-left: 16px;

      &::before {
        content: "";
        display: inline-block;
        width: 32px;
        height: 32px;
        background: url("~@/assets/zs_imgs/skill-more-title-bg-icon.png") no-repeat;
        background-size: cover;
        position: absolute;
        left: -16px;
        top: -6px;
      }

      .icon {
        position: absolute;
        left: -12px;
        top: -3px;
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
    }

    .potential {
      width: 100%;
      margin-bottom: 20px;

      .item {
        display: flex;
        gap: 9px;
        align-items: center;
        margin-bottom: 11px;

        &:last-child {
          margin-bottom: 0;
        }

        .icon {
          width: 26px;
          height: 26px;
          background: #222337;
          border-radius: 4px;
          border: 1px solid #656f74;
        }

        .desc {
          font-weight: 400;
          font-size: 18px;
          color: #bbbbbb;
          line-height: 20px;
        }

        .desc-icon {
          width: 26px;
          height: 26px;
          border-radius: 4px;
        }
      }
    }
  }

  .line {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1);
    margin-bottom: 20px;
  }
}
</style>
